import React, { useState, useEffect } from "react";
import axios from "axios";
import { Apiurl } from "../../../shared/services/apirest";

const ProfileManagement = ({ showToast }) => {
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("profile"); // 'profile' or 'security'

    // User Data State
    const [profile, setProfile] = useState({
        nombre_laboratorio: localStorage.getItem("nombre_investigador") || "",
        email: "",
        telefonos: "",
        direccion: "",
        id_laboratorios: ""
    });

    // Password State
    const [security, setSecurity] = useState({
        old_password: "",
        new_password: "",
        confirm_password: ""
    });

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const token = localStorage.getItem("token");
                const res = await axios.get(`${Apiurl}users/profile/`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setProfile(res.data);
            } catch (err) {
                console.error("Error fetching profile:", err);
            }
        };
        fetchProfile();
    }, []);

    const handleProfileSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const token = localStorage.getItem("token");
            await axios.put(`${Apiurl}users/profile/`, profile, {
                headers: { Authorization: `Bearer ${token}` }
            });
            showToast("✅ Perfil actualizado correctamente.", "success");
            localStorage.setItem("nombre_investigador", profile.nombre_laboratorio);
        } catch (err) {
            showToast("❌ Error al actualizar el perfil.", "danger");
        } finally {
            setLoading(false);
        }
    };

    const handleSecuritySubmit = async (e) => {
        e.preventDefault();
        if (security.new_password !== security.confirm_password) {
            showToast("❌ Las contraseñas nuevas no coinciden.", "danger");
            return;
        }
        setLoading(true);
        try {
            const token = localStorage.getItem("token");
            await axios.post(`${Apiurl}users/change_password/`, {
                old_password: security.old_password,
                new_password: security.new_password
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            showToast("✅ Contraseña actualizada correctamente.", "success");
            setSecurity({ old_password: "", new_password: "", confirm_password: "" });
        } catch (err) {
            showToast("❌ Error al cambiar la contraseña.", "danger");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-fluid px-0 animate__animated animate__fadeIn">
            <div className="mb-4">
                <h2 className="fw-bold text-dark m-0 h3">Gesti&oacute;n de Perfil Institucional</h2>
                <p className="text-muted small">Administre su identidad cl&iacute;nica y configuraciones de seguridad</p>
            </div>

            <div className="row g-4">
                <div className="col-lg-4">
                    <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: '20px' }}>
                        <div className="card-body p-4 text-center">
                            <div className="avatar-circle mx-auto mb-3" style={{ width: '80px', height: '80px', fontSize: '2.5rem' }}>
                                {profile.nombre_laboratorio?.charAt(0) || "U"}
                            </div>
                            <h5 className="fw-bold text-dark mb-1">{profile.nombre_laboratorio}</h5>
                            <p className="text-muted small mb-3">{profile.email}</p>
                            <span className="badge bg-success bg-opacity-10 text-success px-3 py-2 rounded-pill small fw-bold">
                                INVESTIGADOR ACTIVO
                            </span>
                        </div>
                        <div className="list-group list-group-flush border-top">
                            <button
                                className={`list-group-item list-group-item-action border-0 py-3 px-4 d-flex align-items-center gap-3 ${activeTab === 'profile' ? 'active bg-success bg-opacity-10 text-success fw-bold' : ''}`}
                                onClick={() => setActiveTab("profile")}
                            >
                                <i className="bi bi-person-circle fs-5"></i>
                                Datos de Identidad
                            </button>
                            <button
                                className={`list-group-item list-group-item-action border-0 py-3 px-4 d-flex align-items-center gap-3 ${activeTab === 'security' ? 'active bg-success bg-opacity-10 text-success fw-bold' : ''}`}
                                onClick={() => setActiveTab("security")}
                            >
                                <i className="bi bi-shield-lock fs-5"></i>
                                Seguridad y Acceso
                            </button>
                        </div>
                    </div>
                </div>

                <div className="col-lg-8">
                    <div className="card border-0 shadow-sm" style={{ borderRadius: '20px' }}>
                        <div className="card-body p-4">
                            {activeTab === "profile" ? (
                                <form onSubmit={handleProfileSubmit}>
                                    <h5 className="fw-bold text-dark mb-4 border-bottom pb-2">Datos de Usuario</h5>

                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <label className="form-label small fw-bold text-muted">NOMBRE COMPLETO / INSTITUCI&Oacute;N</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={profile.nombre_laboratorio}
                                                onChange={(e) => setProfile({ ...profile, nombre_laboratorio: e.target.value })}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label small fw-bold text-muted">CORREO ELECTR&Oacute;NICO</label>
                                            <input
                                                type="email"
                                                className="form-control bg-light"
                                                value={profile.email}
                                                readOnly
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label small fw-bold text-muted">TEL&Eacute;FONO DE CONTACTO</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={profile.telefonos}
                                                onChange={(e) => setProfile({ ...profile, telefonos: e.target.value })}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label small fw-bold text-muted">DIRECCI&Oacute;N</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={profile.direccion}
                                                onChange={(e) => setProfile({ ...profile, direccion: e.target.value })}
                                            />
                                        </div>
                                    </div>

                                    <div className="mt-4 pt-3 border-top d-flex justify-content-end">
                                        <button className="btn btn-success px-4 fw-bold" disabled={loading}>
                                            {loading ? <span className="spinner-border spinner-border-sm me-2"></span> : "GUARDAR CAMBIOS"}
                                        </button>
                                    </div>
                                </form>
                            ) : (
                                <form onSubmit={handleSecuritySubmit}>
                                    <h5 className="fw-bold text-dark mb-4 border-bottom pb-2">Cambiar Contrase&ntilde;a</h5>

                                    <div className="mb-4 bg-info bg-opacity-10 p-3 rounded-3 border-start border-info border-4">
                                        <p className="text-info small mb-0 fw-bold">
                                            <i className="bi bi-info-circle-fill me-2"></i>
                                            Para mayor seguridad, use una combinaci&oacute;n de letras, n&uacute;meros y caracteres especiales.
                                        </p>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label small fw-bold text-muted">CONTRASE&Ntilde;A ACTUAL</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            value={security.old_password}
                                            onChange={(e) => setSecurity({ ...security, old_password: e.target.value })}
                                            required
                                        />
                                    </div>
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <label className="form-label small fw-bold text-muted">NUEVA CONTRASE&Ntilde;A</label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                value={security.new_password}
                                                onChange={(e) => setSecurity({ ...security, new_password: e.target.value })}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label small fw-bold text-muted">CONFIRMAR CONTRASE&Ntilde;A</label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                value={security.confirm_password}
                                                onChange={(e) => setSecurity({ ...security, confirm_password: e.target.value })}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="mt-4 pt-3 border-top d-flex justify-content-end">
                                        <button className="btn btn-primary px-4 fw-bold" disabled={loading}>
                                            {loading ? <span className="spinner-border spinner-border-sm me-2"></span> : "ACTUALIZAR SEGURIDAD"}
                                        </button>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileManagement;
